export default __webpack_public_path__ + "static/media/task.648772f9.svg";